// ChatLogoIcon: public/icons/chat-logo.svg drawn inline, so its brand paint follows the theme palette.

export const ChatLogoIcon = ({ className = "h-[71px] w-[71px]", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="71"
    height="71"
    viewBox="0 0 71 71"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="35.5" cy="35.5" r="35.5" className="fill-brand-strong" />
    <path
      d="M29.2666 32.1992C31.4444 33.9103 37.0133 36.3059 41.8666 32.1992"
      className="stroke-surface"
    />
    <path
      d="M42.0019 22H29.5981C23.7449 22 19 26.7449 19 32.5981V35.7027C19 39.8413 22.355 43.1963 26.4935 43.1963V50L37.2 43.1963H42.0019C47.8551 43.1963 52.6 38.4513 52.6 32.5981C52.6 26.7449 47.855 22 42.0019 22Z"
      className="stroke-surface"
    />
  </svg>
);
